import { useState } from 'react';
import { GridSortItem, GridSortModel } from '@mui/x-data-grid';
import { useGetDatasetsInfiniteQuery } from '~/api/v2/hooks';
import { TableFilters, resolveFilterValues } from '~/components/Table/components/filters/types';
import { DatasetFilters, DatasetFiltersType } from '~/pages/DataCatalogPage/components/DatasetsTable';
import { DatasetAccessTables, datasetAccessConfig } from '~/pages/DataCatalogPage/types';
import useDatasetsFilters from './useDatasetsFilters';

const useDatasetsTable = (tableType: DatasetAccessTables) => {
  const [sortModel, setSortModel] = useState<GridSortItem | null>(null);
  const [searchText, setSearchText] = useState<string>('');

  const { filterOptions, filters, setFilters } = useDatasetsFilters();

  const { data, isFetching, isError, fetchNextPage, hasNextPage } = useGetDatasetsInfiniteQuery({
    isMy: tableType === DatasetAccessTables.MY_DATASETS,
    status: datasetAccessConfig[tableType],
    sort: sortModel?.field,
    order: sortModel?.sort,
    search: searchText,
    statusList: resolveFilterValues(filters[DatasetFiltersType.STATUS]),
    anatomyList: resolveFilterValues(filters[DatasetFiltersType.ANATOMY]),
    modalityList: resolveFilterValues(filters[DatasetFiltersType.MODALITY]),
    ouOwnerList: filters[DatasetFiltersType.OU_OWNER].map((filter) => filter.label),
    dataSourceCategoryList: filters[DatasetFiltersType.DATA_SOURCE_CATEGORY].map((filter) => filter.label),
    dataSourceType: filters[DatasetFiltersType.DATA_SOURCE_TYPE][0]?.label,
  });

  const rows = [...new Map((data?.pages?.flatMap((page) => page.data) ?? []).map((item) => [item.id, item])).values()];
  const rowCount = data?.pages[0].pagination.total;

  return {
    rows,
    rowCount,
    onSortChange: (sortModel: GridSortModel) => setSortModel(sortModel[0] || null),
    onFiltersChange: (filters: TableFilters) => setFilters(filters as DatasetFilters),
    onSearchChange: setSearchText,
    filterOptions,
    isFetching,
    isError,
    onLoadMore: fetchNextPage,
    hasNextPage,
    tableType,
    sortModel: sortModel ? [{ ...sortModel }] : [],
    initialFiltersModel: filters,
    initialSearchText: searchText,
  };
};

export default useDatasetsTable;
